var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7511 9.75117V5.29741C15.7511 4.30271 15.3559 3.34874 14.6526 2.64538C13.9492 1.94202 12.9952 1.54688 12.0005 1.54688C11.0058 1.54688 10.0519 1.94202 9.34851 2.64538C8.64514 3.34874 8.25 4.30271 8.25 5.29741V9.75117",
    stroke: "#787395",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2502 9.75H6.75024C5.5076 9.75 4.50024 10.7574 4.50024 12V20.25C4.50024 21.4926 5.5076 22.5 6.75024 22.5H17.2502C18.4929 22.5 19.5002 21.4926 19.5002 20.25V12C19.5002 10.7574 18.4929 9.75 17.2502 9.75Z",
    stroke: "#787395",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 14.9473,
    r: 1.47368,
    fill: "#787395"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9648 15.939C11.0969 15.4768 11.5193 15.1582 12 15.1582C12.4806 15.1582 12.903 15.4768 13.0351 15.939L13.3742 17.1258C13.635 18.0388 12.9495 18.9477 12 18.9477C11.0504 18.9477 10.3649 18.0388 10.6257 17.1258L10.9648 15.939Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/lock2.b8ba43aa.svg";
export { ForwardRef as ReactComponent };